import { render, staticRenderFns } from "./PackedOrdersTable.vue?vue&type=template&id=165cdbc6&scoped=true"
import script from "./PackedOrdersTable.vue?vue&type=script&lang=js"
export * from "./PackedOrdersTable.vue?vue&type=script&lang=js"
import style0 from "./PackedOrdersTable.vue?vue&type=style&index=0&id=165cdbc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165cdbc6",
  null
  
)

export default component.exports